<template>
    <div v-if="activeFilters && activeFilters.length > 0" class="flex flex-row items-center space-x-2 w-full">
    <div 
        v-if="showResetFilters" 
        @click="clearAllActiveFilters()" 
        class="bg-indigo-50 border border-indigo-100 hover:bg-indigo-100 hover:border-indigo-200 text-indigo-900 flex items-center justify-between rounded-sm p-1.5 cursor-pointer"
    >
            Reset Filters
    </div>
    <base-pill class="bg-amber-300 border-amber-400 flex items-center justify-between space-x-0.5 p-0.5" v-for="filter in activeFilters" :key="filter.name">
        <div>
            {{ filter.name }}: {{ getFilterDisplay(filter.value) }}
        </div>
        <button @click="clearFilter(filter.filter)">✕</button> 
    </base-pill>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, watch, computed } from 'vue';

const props = defineProps(['activeFilters', 'showClearAll'])

const emit = defineEmits(['clear-filter', 'clear-all-active-filters'])

watch(props.activeFilters, ()=> {
    // console.log('active filters changed')
}, {deep: true})


const showResetFilters = computed(() => {
    if(props.showClearAll) {
        if(props.activeFilters.length > 0) {
            return true
        }
    }
    return false
})

function clearFilter(filterKey) {
    emit('clear-filter', filterKey)
}

function clearAllActiveFilters() {
    emit('clear-all-active-filters')
}

function getFilterDisplay(filterValue) {
    let displayString = ''
    if(Array.isArray(filterValue)) {
        if(filterValue.length > 2) {
            let numOverflowValues = filterValue.length - 2
            displayString = `${filterValue[0]}, ${filterValue[1]} & ${numOverflowValues} More`
        } else {
            filterValue.forEach((value) => {
                displayString += `${value}, `
            })
        }
    } else {
        displayString = `${filterValue}`
    }
    return displayString.trim().replace(/,\s*$/, "");
}
</script>